import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
import { IconMoney, IconCredit, IconAI, IconSoftware, IconRewards, IconBusiness } from './icons/BlinkIcons';
export function Ecosystem() {
  const {
    t
  } = useLanguage();
  const cards = [{
    title: t('ecosystem.cards.money.title'),
    icon: IconMoney,
    desc: t('ecosystem.cards.money.desc')
  }, {
    title: t('ecosystem.cards.credit.title'),
    icon: IconCredit,
    desc: t('ecosystem.cards.credit.desc')
  }, {
    title: t('ecosystem.cards.ai.title'),
    icon: IconAI,
    desc: t('ecosystem.cards.ai.desc')
  }, {
    title: t('ecosystem.cards.software.title'),
    icon: IconSoftware,
    desc: t('ecosystem.cards.software.desc')
  }, {
    title: t('ecosystem.cards.rewards.title'),
    icon: IconRewards,
    desc: t('ecosystem.cards.rewards.desc')
  }, {
    title: t('ecosystem.cards.business.title'),
    icon: IconBusiness,
    desc: t('ecosystem.cards.business.desc')
  }];
  return <section className="py-20 md:py-32 relative z-10" id="ecosystem" data-id="element-5">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-6">
        <div className="mb-12 md:mb-24" data-id="element-7">
          <h2 className="text-[40px] leading-[1.05] md:text-4xl font-display font-medium mb-4" data-id="element-8">
            {t('ecosystem.title')}
          </h2>
          <p className="text-white/50 text-[18px] leading-[1.5] md:text-lg max-w-2xl font-light" data-id="element-9">
            {t('ecosystem.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-10">
          {cards.map((card, index) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group glass-panel p-7 md:p-10 rounded-[2rem] md:hover:bg-surface/60 transition-all duration-300 cursor-pointer border border-white/5 md:hover:border-accent/30 md:hover:-translate-y-[2px] active:scale-[0.98] shadow-[0_4px_24px_rgba(0,0,0,0.2)] md:hover:shadow-[0_12px_40px_rgba(255,106,0,0.15)] relative overflow-hidden flex flex-col justify-start min-h-[240px]" data-id="element-11">
              <div className="absolute inset-0 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)] rounded-[2rem] pointer-events-none" data-id="element-12" />
              <div className="absolute inset-0 bg-gradient-to-br from-accent/[0.02] to-transparent opacity-0 md:group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-13" />
              <div className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center mb-6 md:mb-8 md:group-hover:bg-white/10 transition-transform duration-300 md:group-hover:-translate-y-[2px] shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)] relative z-10 shrink-0" data-id="element-14">
                <card.icon className="w-6 h-6 text-white/60 md:group-hover:text-white transition-colors duration-300" data-id="element-15" />
              </div>
              <h3 className="text-[28px] md:text-2xl font-display font-medium mb-3 md:mb-4 text-white/90 md:group-hover:text-white transition-colors relative z-10" data-id="element-16">
                {card.title}
              </h3>
              <p className="text-white/50 text-[17px] md:text-base leading-relaxed font-light relative z-10" data-id="element-17">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}